import React from 'react';
import { Box } from '@mui/material';

import { modalFooterStyles } from './modalV2.style';

const ModalFooter = ({ children, styles = {} }) => {
  return <Box sx={{ ...modalFooterStyles.wrapper, ...styles }}>{children}</Box>;
};

export default ModalFooter;
